import { MultiToken, Plugin, State, createTokenClass, registerPlugin } from 'linkifyjs'

const SCHEME_LIKE_TOKENS = new Set(['SCHEME', 'SLASH_SCHEME', 'LOCALHOST'])

const CommandToken = createTokenClass('bot-command', {
  isLink: true,
  toHref () {
    return '#'
  },
})

const BotToken = createTokenClass('bot-token', {
  isLink: true,
  toHref () {
    return '#'
  },
})

type ParserState = State<MultiToken>

const botControlPlugin: Plugin = ({ scanner, parser }) => {
  const { SLASH, HYPHEN, UNDERSCORE, COLON, DOLLAR } = scanner.tokens
  const idTokens = scanner.tokens.groups.alphanumeric ?? []
  const commandTokens = idTokens.filter((token) => !SCHEME_LIKE_TOKENS.has(token))

  // linkifyjs types State generic as the token class, not MultiToken
  const Command = new State(CommandToken) as unknown as ParserState
  const CommandJoin = new State() as ParserState
  // Clone existing SLASH transition so protocol-relative URLs are not dropped.
  const afterSlash = parser.start.tt(SLASH)
  commandTokens.forEach((token) => {
    afterSlash.tt(token, Command)
    Command.tt(token, Command)
    CommandJoin.tt(token, Command)
  })
  Command.tt(UNDERSCORE, CommandJoin)
  Command.tt(HYPHEN, CommandJoin)
  CommandJoin.tt(UNDERSCORE, CommandJoin)
  CommandJoin.tt(HYPHEN, CommandJoin)

  const Token = new State(BotToken) as unknown as ParserState
  const afterColon = new State() as ParserState
  commandTokens.forEach((token) => {
    afterColon.tt(token, Token)
    Token.tt(token, Token)
  })
  Token.tt(HYPHEN, Token)
  Token.tt(UNDERSCORE, Token)

  const attachBotId = (fromState: ParserState) => {
    commandTokens.forEach((token) => {
      // Clone existing WORD/TLD/… transitions so www/email/url keep working.
      const botId = fromState.tt(token)
      botId.tt(COLON, afterColon)
      commandTokens.forEach((nextToken) => botId.tt(nextToken, botId))
      botId.tt(HYPHEN, botId)
      botId.tt(UNDERSCORE, botId)
    })
  }

  attachBotId(parser.start)
  attachBotId(parser.start.tt(DOLLAR))
}

export const LinkifyBotControlPlugin = {
  install: () => {
    registerPlugin('bot-control', botControlPlugin)
  },
}
